// @flow
/**
 * Name: CustomAlertBox - JS komponenta k extenzi AlertBox
 * Description: Informační box/pruh - komponenta se zobrazí v případě, kdy v cookie neexistuje záznam s příslušným id. Komponenta obsahuje subwidget pro zavření, který skryje aktuální zprávu a do cookie uloží příslušné id.
 */
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import cookie from 'js-cookie';
const fragments = {
  CLOSE: '[data-fragment="CustomAlertBox.close"]',
};
const COOKIE_KEY = 'TFS_info_box';
export default class CustomAlertBox extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  didMount() {
    this.on('click', fragments.CLOSE, this.handleClick);
    this.createCookie(COOKIE_KEY);
    this.loadAlerts();
    // Po načtení upozornění, pokud se komponenta zobrazuje,
    // nastavíme fokus na tlačítko zavření a aktivujeme posluchače pro klávesu ESC.
    if (this.element.classList.contains('show')) {
      const closeBtn = this.element.querySelector(fragments.CLOSE);
      if (closeBtn) {
        closeBtn.focus();
      }
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }
  /**
   * Obsluha události, která detekuje stisk klávesy ESC a,
   * pokud je stisknuta, zavře alert box.
   */
  handleKeyDown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      this.handleClick();
    }
  }
  handleClick() {
    const cookieText = cookie.get(COOKIE_KEY);
    const cookieExp = this.props.cookieExpires || 1;
    const idArray = JSON.parse("[" + cookieText + "]");
    idArray.push(this.props.alertId);
    cookie.set(COOKIE_KEY, idArray.toString(), { expires: cookieExp });
    this.element.classList.remove('show');
    // Po zavření odstraníme posluchače události klávesnice.
    document.removeEventListener('keydown', this.handleKeyDown);
  }
  loadAlerts() {
    const alertsToHide = JSON.parse("[" + cookie.get(COOKIE_KEY) + "]");
    if (!alertsToHide.includes(this.props.alertId)) {
      this.element.classList.add('show');
    }
  }
  createCookie(key) {
    if (!cookie.get(key)) cookie.set(key, '');
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CustomAlertBox.js